// constants
import { showSuccessAlert } from "../../constants/alerts";
import { ComplaintsActionTypes } from "./constants";

const INIT_STATE = {
  complaints: [],
  pagination: null,
  loading: false,
  initialLoading: false,
  error: null,
};

interface ComplaintsActionType {
  type:
    | ComplaintsActionTypes.API_RESPONSE_SUCCESS
    | ComplaintsActionTypes.API_RESPONSE_ERROR
    | ComplaintsActionTypes.GET_COMPLAINTS
    | ComplaintsActionTypes.CHANGE_STATUS;

  payload: {
    actionType?: string;
    data?: any | {};
    error?: string;
    message?: string;
  };
}

const Complaints = (state: any = INIT_STATE, action: ComplaintsActionType): any => {
  switch (action.type) {
    case ComplaintsActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case ComplaintsActionTypes.GET_COMPLAINTS: {
          return {
            ...state,
            complaints: action.payload.data.complaints || action.payload.data,
            pagination: action.payload.data.pagination || null,
            loading: false,
            initialLoading: false,
            error: null,
          };
        }

        case ComplaintsActionTypes.CHANGE_STATUS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        default:
          return { ...state };
      }

    case ComplaintsActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case ComplaintsActionTypes.GET_COMPLAINTS:
        case ComplaintsActionTypes.CHANGE_STATUS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }

        default:
          return { ...state };
      }

    case ComplaintsActionTypes.GET_COMPLAINTS:
    case ComplaintsActionTypes.CHANGE_STATUS:
      return { ...state, loading: true, initialLoading: true };

    default:
      return { ...state };
  }
};

export default Complaints;
